import React from 'react';
import styles from './OnlineDomainHeader.scss';
import ComponentSearchDomainForm from '../../../components/ComponentSearchDomainForm/ComponentSearchDomainForm';


export default function OnlineDomainHeader({tld, xnOnly}) {
	const placeholder = xnOnly ? 'моятдомейн.' : 'mysupersite.';
	return (
	  <header className={styles.header}>
		  <div className={styles.innerHeader}>
			  <ComponentSearchDomainForm
				isTransparent={true}
				doNotCalcInputWidth={true}
				placeholder={placeholder + tld}
				animationPlaceholders={[placeholder + tld]}/>
		  </div>
	  </header>
	)
}